import { Injectable } from '@angular/core';
import {NetworkFilterService} from '../network/network-filter.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class NodeFilterService {

  constructor() { }

  public static mapFilter(nodes: any, searchObject: any) {
    const searchableFields = ['nodes', 'pCons', 'connections', 'voipPeers', 'administrative state', 'operative state', 'name'];
    const searchObjectCopy = NetworkFilterService.formatSearchObject(searchObject);

    let filteredNodes = _.cloneDeep(nodes);

    const markFilteredNodes = (nodeList, filtered) => {
      nodeList = nodeList.map((node) => {
        node.filtered = isElementFiltered(filtered, node);
        return node;
      });
      return nodeList;
    };

    const filterByNameAndIp = (nodeList, nameObject) => {
      if (nameObject && nameObject.value) {
        nodeList = nodeList.filter((node) => {
          return node.name.toLowerCase().indexOf(nameObject.value.toLowerCase()) > -1
            || node.ipAddr.indexOf(nameObject.value) > -1
            || node.addressForGUI.indexOf(nameObject.value) > -1;
        });
      }
      return nodeList;
    };

    const filterByAdminState = (nodeList, adminStateObject) => {
      if (adminStateObject && adminStateObject.value) {
        nodeList = nodeList.filter((node) => {
          return  adminStateObject.value.toLowerCase() === node.adminState.toLowerCase();
        });
      }
      return nodeList;
    };

    const filterByOperState = (nodeList, operStateObject) => {
      if (operStateObject && operStateObject.value) {
        nodeList = nodeList.filter((node) => {
          if (!_.isArray(operStateObject.value)) {
            return  operStateObject.value.toLowerCase() ===  node.operState.description.toLowerCase();
          }
          return operStateObject.value.find((state) => {
            return  state.toLowerCase() === node.operState.description.toLowerCase();
          });
        });
      }
      return nodeList;
    };

    const filterByName = (nodeList, nameObject) => {
      if (nameObject && nameObject.value) {
        nodeList = nodeList.filter((node) => {
          return node.name.toLowerCase().indexOf(nameObject.value.toLowerCase()) > -1;
        });
      }
      return nodeList;
    };

    const isElementFiltered = (array, searchedObject) => {
      return !!array.find((arrayItem) => {
        return arrayItem.id === searchedObject.id;
      });
    };

    if (!searchObjectCopy) {
      return filteredNodes;
    }

    if (searchObjectCopy.freeText) {
      searchObjectCopy.name = {value: searchObjectCopy.freeText};
      filteredNodes = filterByNameAndIp(filteredNodes, searchObjectCopy.name);
      return markFilteredNodes(nodes, filteredNodes);
    }

    if (!searchObjectCopy.nodes) {
      return markFilteredNodes(nodes, []);
    }

    if (!searchObjectCopy.nodes.value  || searchObjectCopy.nodes.value === 'no') {
      return markFilteredNodes(nodes, []);
    }

    if (NetworkFilterService.haveNonSearchableFields(searchObjectCopy, searchableFields)) {
      return markFilteredNodes(nodes, []);
    }

    filteredNodes = filterByName(filteredNodes, searchObjectCopy.name);
    filteredNodes = filterByAdminState(filteredNodes, searchObjectCopy['administrative state']);
    filteredNodes = filterByOperState(filteredNodes, searchObjectCopy['operative state']);
    return markFilteredNodes(nodes, filteredNodes);
  }

  public static testRouteFilter(nodes, testRoutePath) {
    const nodesToFilter = [];

    if (testRoutePath.edges) {
      testRoutePath.edges.forEach((edge) => {
        if (nodesToFilter.indexOf(edge.connSrcNode) === -1) {
          nodesToFilter.push (edge.connSrcNode);
        }
        if (nodesToFilter.indexOf(edge.connDestNode) === -1) {
          nodesToFilter.push (edge.connDestNode);
        }
      });
    } else {
      nodesToFilter.push (testRoutePath.destNode);
    }

    nodes = nodes.map((node) => {
      if (nodesToFilter.filter(nodeToFilter => {
        return nodeToFilter === node.id; }).length > 0) {
        node.testRouteFilter = true;
      }
      return node;
    });
    return nodes;
  }
}
